import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Loader from 'react-loaders';
import { useEvaluationRequest } from 'Api/Coordinator/Verzoeken';

function EvaluationRequest() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const hash = queryParams.get('h');
    const userType = queryParams.get('u');
    const { data, error } = useEvaluationRequest(hash, userType);
    
    useEffect(() => {
        if (data?.data?.status) {
            window.location.href = data.data.data;
        }
    }, [data]);

    useEffect(() => {
        if (error) {
            console.error(error);
        }
    }, [error]);

    return (
        <div className="p-4">
            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                <Loader
                    type="ball-pulse"
                    className={'mt-3 d-flex mx-auto justify-content-center'}
                />
            </div>
        </div>
    );
}

export default EvaluationRequest;